<template>
   <div class="DataUpdate eval-docente-adm">
      <transition name="modalFade">
         <div v-if="showModalDetail" class="modal">
            <div class="modalContentDetails">
               <div class="modalHeaderDetails">
                  <h3>Detalle</h3>
                  <button class="closeButton" @click="closeModal" aria-label="Cerrar detalle">
                  X
                  </button>
               </div>
               <div v-if="modalData" class="modal-body-details">
                  <div v-html="modalData.det_Form"></div>
               </div>
            </div>
         </div>
         <div v-if="showModalDetailI" class="modal">
            <div v-if="confirmationModal" class="modalContentDetailsC-E">
               <div class="modalHeaderDetailsC-E">
                  <h3>
                     {{ modalValidationMessage ? 'Editar Formulario' : 'Crear Formulario' }}
                  </h3>
                  <div class="closeButtonContainerC-E">
                     <button class="closeButtonC-E" @click="closeModalI" aria-label="Cerrar formulario">
                     X
                     </button>
                  </div>
               </div>
               <div class="modal-body-detailsC-E">
                  <EvalCreate
                     @OpenConfirmationMessage="openConfirmationMessage"
                     :dataEdit="dataEditValidator"
                     :validationAction="validationActionValidator"
                     />
               </div>
            </div>
            <div v-if="showModalQuestion" class="modalContentQuestion">
               <div v-if="showModalQuestionforQ" class="modalDefaultQuestionContainer">
                  <h4>
                     ¿Desea traer las preguntas por defecto del formulario?
                  </h4>
                  <div class="modalButtonsQuestionContainer">
                     <button
                        @click="openQuestionModalYes"
                        class="loginbtn primaryBtn buttonYes"
                        >
                     Sí
                     </button>
                     <button
                        @click="openQuestionModalNo"
                        class="loginbtn secondaryBtn buttonNo"
                        >
                     No
                     </button>
                  </div>
               </div>
               <div
                  v-if="showModalQuestionforQuestions"
                  class="modalQuestionforQuestions"
                  id="modalQuestionsIbero"
                  >
                  <div class="modalHeaderQuestion">
                     <h3>Preguntas</h3>
                     <div class="closeButtonContainerQuestion">
                        <button
                           class="closeButtonQuestion"
                           @click="closeModalQuestion"
                           aria-label="Cerrar preguntas"
                           >
                        X
                        </button>
                     </div>
                  </div>
                  <div>
                     <div
                        v-if="questionData.length === 0"
                        class="modalQuestionforAdd"
                        >
                        <p>El formulario actualmente no contiene preguntas</p>
                     </div>
                     <div
                        class="error-message"
                        v-if="isValidationErrorVisibleAdd2"
                        >
                        {{ validationErrorMessageAdd2 }}
                     </div>
                     <ul class="questionsContainer">
                        <li
                           v-for="(question,index) in questionData"
                           :key="question.id_Question"
                           >
                           <div class="questionsContainer__part1">
                              <div
                                 v-if="editIndex !== question.id_Question"
                                 class="questionsContainer__li"
                                 >
                                 <span>{{question.nam_Question}}</span>
                              </div>
                              <span
                                 v-else
                                 class="questionsContainer__part2"
                                 >
                                 <input
                                    id="inputQuestion"
                                    v-model="question.nam_Question"
                                    @keyup.enter="keepEdition"
                                    />
                                 <button class="loginbtn primaryBtn eval-docente-adm__inline-btn" @click="keepEdition(question.nam_Question)">
                                 Guardar
                                 </button>
                                 <div
                                    class="error-message"
                                    v-if="isValidationErrorVisible"
                                    >
                                    {{ validationErrorMessage }}
                                 </div>
                                 <div
                                    class="error-message"
                                    v-if="isValidationErrorVisibleAdd"
                                    >
                                    {{ validationErrorMessageAdd }}
                                 </div>
                              </span>
                              <div class="questionsContainer__images">
                                 <a @click="editarItem(question.id_Question)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-pencil-minus" width="35" height="35" viewBox="0 0 24 24" stroke-width="1.5" stroke="#9e9e9e" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                       <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                       <path d="M8 20l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4z" />
                                       <path d="M13.5 6.5l4 4" />
                                       <path d="M16 18h4" />
                                    </svg>
                                 </a>
                                 <a
                                    v-if="buttonDeleteQuestion"
                                    @click="deleteItem(index)"
                                    >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-trash" width="35" height="35" viewBox="0 0 24 24" stroke-width="1.5" stroke="#9e9e9e" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                       <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                       <path d="M4 7l16 0" />
                                       <path d="M10 11l0 6" />
                                       <path d="M14 11l0 6" />
                                       <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                       <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                    </svg>
                                 </a>
                              </div>
                           </div>
                           <div
                              class="containerCheck"
                              v-if="buttonDeleteQuestion"
                              >
                              <input
                                 v-model="question.type_Generic_Form"
                                 :checked="question.type_Generic_Form"
                                 @change="handleCheckboxChange(question)"
                                 type="checkbox"
                                 title="Activa la casilla si la pregunta es de respuesta libre."
                                 />
                              <span>
                              Convertir a pregunta abierta
                              </span>
                           </div>
                        </li>
                        <li v-if="showModalNewQuestion">
                           <span class="containerNewQuestions">
                              <input
                                 id="inputNewQuestion"
                                 type="text"
                                 v-model="newQuestion"
                                 />
                              <button class="loginbtn primaryBtn eval-docente-adm__inline-btn" @click="addItem">
                              Guardar
                              </button>
                              <div
                                 class="error-message"
                                 v-if="isValidationErrorVisibleNew"
                                 >
                                 {{ validationErrorMessageNew }}
                              </div>
                              <div
                                 class="error-message"
                                 v-if="isValidationErrorVisibleAdd3"
                                 >
                                 {{ validationErrorMessageAdd3 }}
                              </div>
                           </span>
                        </li>
                     </ul>
                     <div class="buttonCreateNewQuestion1">
                        <button
                           v-if="buttonDeleteQuestion"
                           @click="addNewQuestion"
                           class="loginbtn primaryBtn"
                           >
                        Agregar pregunta
                        </button>
                     </div>
                     <div class="buttonCreateNewQuestion2">
                        <button
                           @click="closeModalQuestion"
                           class="loginbtn secondaryBtn buttonCreateNewQuestion2_button1"
                           >
                        Cancelar
                        </button>
                        <button
                           v-if="questionData.length !== 0"
                           @click="sendQuestions"
                           class="loginbtn primaryBtn buttonCreateNewQuestion2_button2"
                           >
                        Guardar
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </transition>
      <div class="titlePage">
         Administración - Evaluación Docente
      </div>
      <va-notification v-if="confirmationMessage" color="info">
         <p>
            {{ modalValidationMessage
            ? 'Registro Editado Correctamente'
            : 'Registro Creado Correctamente' }}
         </p>
      </va-notification>
      <va-notification
         v-if="confirmationMessageQuestions"
         color="info"
         >
         <p>Preguntas Agregadas Correctamente</p>
      </va-notification>
      <TableList
         ref="table-list"
         :InfoView="tableData"
         :HeadTable="tableColumns"
         @OpenModalDetails="openModal"
         @OpenModalInsertData="openModalI"
         :GenericFormQuestions="genericFormQuestions"
         />
   </div>
</template>
<script>
// Importa el componente de Vuex
import IberoHelpers from '@/store/helpers.js'
// Importa el componente para el manejo del formulario de creación y edición de la tabla Generic-Form
import EvalCreate from '../../components/EvalDocenteAdm/EvalDocenteAdmCreate.vue'
// Importa el componente que tiene la lógica de la tabla que se imprime de Generic-Form
import TableList from '@/components/data-tables/DataEvalDocenteAdm.vue'

export default {
  // Se exportan los componentes a utilizar
  components: {
    TableList,
    EvalCreate,
  },
  data () {
    return {
      // Se declaran las variables para el tratamiento de la data, y la lógica del front
      selectedQuestion: false,
      buttonDeleteQuestion: false,
      confirmationMessageQuestions: false,
      isValidationErrorVisibleAdd3: false,
      validationErrorMessageAdd3: '',
      isValidationErrorVisibleAdd2: false,
      validationErrorMessageAdd2: '',
      isValidationErrorVisibleAdd: false,
      validationErrorMessageAdd: '',
      validationErrorMessageNew: '',
      isValidationErrorVisibleNew: false,
      validationErrorMessage: '',
      isValidationErrorVisible: false,
      showModalNewQuestion: false,
      newQuestion: '',
      editIndex: '',
      questionRegist: 0,
      registQuestionData: 0,
      showModalQuestionforQuestions: false,
      showModalQuestionforQ: false,
      showModalQuestion: false,
      validationActionM: false,
      modalValidationMessage: false,
      confirmationModal: false,
      confirmationMessage: false,
      showModalDetailI: false,
      modalData: null,
      showModalDetail: false,
      genericFormQuestions: [],
      tableData: [],
      questionData: [],
      formEditModel: {
        id_Generic_Form: '',
        date_Form_Start: '',
        date_Form_End: '',
        nam_Form: '',
        det_Form: '',
        sta_Form: '',
        id_Role: '',
        id_Period: '',
        id_Form_Type: '',
        roleId: '',
        formTypeId: '',
      },
      tableColumns: [
        {
          name: 'id_Generic_Form',
          title: 'Id',
          sortField: 'id_Generic_Form',
          dataClass: 'text-center',
          width: '1%',
        },
        {
          name: 'date_Form_Start',
          title: 'Fecha Inicio',
          sortField: 'date_Form_Start',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'date_Form_End',
          title: 'Fecha Fin',
          sortField: 'date_Form_End',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'nam_Form',
          title: 'Nombre Formulario',
          sortField: 'nam_Form',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: '__slot:det_Form',
          title: 'Detalle',
          dataClass: 'text-center',
          sortField: 'det_Form',
          width: '5%',
          actionRef: [
            {
              label: 'OpenDet',
              icon: 'equis',
              action: 'openDet',
            },
          ],
        },
        {
          name: 'sta_Form',
          title: 'Estado',
          sortField: 'sta_Form',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'id_Role',
          title: 'Rol',
          sortField: 'id_Role',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'id_Period',
          title: 'Periodo',
          sortField: 'id_Period',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'id_Form_Type',
          title: 'Tipo Formulario',
          sortField: 'id_Form_Type',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: '__slot:actionsFirst',
          title: '',
          dataClass: 'text-center',
          width: '2%',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
        {
          name: '__slot:actions',
          title: '',
          dataClass: 'text-center',
          width: '2%',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
            {
              label: 'OpenDet',
              icon: 'equis',
              action: 'openDet',
            },
            {
              label: 'OpenQuestion',
              icon: 'fa-pencil',
              action: 'question',
            },
          ],
        },
      ],
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // Se cargan los datos de la tabla Generic_Form, se eliminan, los datos de tiempo en las fechas, se cambian los estados de booleano a string
    loadData () {
      IberoHelpers.GetEvalDocenteAdm(this.$store, 0)
        .then(response => {
          const formattedData = response.data.map(item => {
            item.date_Form_Start = item.date_Form_Start.split('T')[0]
            item.date_Form_End = item.date_Form_End.split('T')[0]
            item.sta_Form = item.sta_Form ? 'Activo' : 'Inactivo'
            return item
          })
          this.tableData = formattedData
        })
        .catch(error => {
          console.error('Error loading data:', error)
        })
      IberoHelpers.GetEvalDocenteAdmGFQuestions(this.$store, 0)
        .then(response => {
          this.genericFormQuestions = response.data
        })
        .catch(error => {
          console.error('Error loading data:', error)
        })
    },
    loadQuestionData (idTypeForm) {
      IberoHelpers.GetEvalDocenteAdmGetQuestions(this.$store, idTypeForm)
        .then(response => {
          this.questionData = response.data
        })
        .catch(error => {
          console.error('Error loading data:', error)
        })
    },

    loadQuestionDataTwo (idTypeForm) {
      IberoHelpers.GetEvalDocenteAdmQuestionsTwo(this.$store, idTypeForm)
        .then(response => {
          this.questionData = response.data
        })
        .catch(error => {
          console.error('Error loading data:', error)
        })
    },

    openModal (formData) {
      this.modalData = formData
      this.showModalDetail = true
    },
    closeModal () {
      this.modalData = null
      this.showModalDetail = false
    },
    openModalI (action, objectData) {
      this.showModalDetailI = true
      if (action === 'create') {
        this.confirmationModal = true
        this.modalValidationMessage = false
        this.validationActionM = false
      } else if (action === 'edit') {
        this.confirmationModal = true
        this.modalValidationMessage = true
        this.validationActionM = true
        this.formEditModel.id_Generic_Form = objectData.id_Generic_Form
        this.formEditModel.date_Form_Start = objectData.date_Form_Start
        this.formEditModel.date_Form_End = objectData.date_Form_End
        this.formEditModel.nam_Form = objectData.nam_Form
        this.formEditModel.det_Form = objectData.det_Form
        this.formEditModel.sta_Form = objectData.sta_Form
        this.formEditModel.id_Role = objectData.id_Role
        this.formEditModel.id_Period = objectData.id_Period
        this.formEditModel.id_Form_Type = objectData.id_Form_Type
        this.formEditModel.roleId = objectData.roleId
        this.formEditModel.formTypeId = objectData.formTypeId
      } else if (action === 'question') {
        this.questionRegist = objectData.formTypeId
        this.registQuestionData = objectData.id_Generic_Form
        this.showModalQuestion = true
        this.showModalQuestionforQ = true
        this.buttonDeleteQuestion = true
      } else if (action === 'questionTwo') {
        this.registQuestionData = objectData.id_Generic_Form
        this.showModalQuestion = true
        this.loadQuestionDataTwo(objectData.id_Generic_Form)
        this.showModalQuestionforQuestions = true
        this.buttonDeleteQuestion = false
      }
    },
    closeModalI () {
      this.showModalDetailI = false
      this.confirmationModal = false
      this.modalValidationMessage = false
      this.validationActionM = false
      for (let key in this.formEditModel) {
        this.formEditModel[key] = ''
      };
    },
    closeModalQuestion () {
      this.showModalDetailI = false
      this.showModalQuestion = false
      this.showModalQuestionforQuestions = false
      this.questionData = []
      this.questionRegist = 0
      this.registQuestionData = 0
      this.buttonDeleteQuestion = false
      this.showModalNewQuestion = false
    },
    openConfirmationMessage () {
      setTimeout(() => {
        this.showModalDetailI = false
        this.confirmationModal = false
        this.validationActionM = false
        for (let key in this.formEditModel) {
          this.formEditModel[key] = ''
        };
        setTimeout(() => {
          this.confirmationMessage = true
          setTimeout(() => {
            this.confirmationMessage = false
            this.tableUpdate()
          }, 3000)
        }, 200)
      }, 50)
    },
    tableUpdate () {
      this.$refs['table-list'].updateTableData(this.loadData())
    },
    openQuestionModalYes () {
      this.loadQuestionData(this.questionRegist)
      this.showModalQuestionforQ = false
      this.showModalQuestionforQuestions = true
    },
    openQuestionModalNo () {
      this.showModalQuestionforQ = false
      this.showModalQuestionforQuestions = true
    },
    editarItem (index) {
      if (this.editIndex === '') {
        this.editIndex = index
      }
    },

    keepEdition (questionEdit) {
      const inputElement = document.getElementById('inputQuestion')

      if (inputElement instanceof HTMLInputElement) {
        if (questionEdit === '') {
          const errorMessage = 'La pregunta no puede estar vacía.'
          this.validationErrorMessage = errorMessage
          this.isValidationErrorVisible = true
          setTimeout(() => {
            this.isValidationErrorVisible = false
          }, 3000)
        } else {
          this.validationErrorMessage = ''
          this.isValidationErrorVisible = false // Oculta el mensaje de error
          this.editIndex = '' // Finaliza la edición
        }
      } else {
        console.error('El elemento inputQuestion no es un input válido.')
      }
    },

    deleteItem (index) {
      if (this.editIndex === '') {
        this.questionData.splice(index, 1)
      }
    },

    addNewQuestion () {
      if (this.questionData.length === 0) {
        const addQuestion = document.querySelector('.modalQuestionforAdd')
        addQuestion.style.display = 'none'
      }
      this.showModalNewQuestion = true
      setTimeout(() => {
        const modalQuestioncontainerCheck = document.getElementById('modalQuestionsIbero')
        if (modalQuestioncontainerCheck) {
          modalQuestioncontainerCheck.scrollTop = modalQuestioncontainerCheck.scrollHeight
        }
      }, 100)
    },
    addItem () {
      const inputElement = document.getElementById('inputNewQuestion')

      if (inputElement instanceof HTMLInputElement) {
        if (this.newQuestion === '') {
          const errorMessage = 'La pregunta no puede estar vacía.'
          this.validationErrorMessageNew = errorMessage
          this.isValidationErrorVisibleNew = true
          setTimeout(() => {
            this.isValidationErrorVisibleNew = false
          }, 3000)
        } else {
          this.validationErrorMessageNew = ''
          this.isValidationErrorVisibleNew = false
          let maxId = -Infinity
          let maxIdForm = -Infinity
          if (this.questionData.length === 0) {
            maxId = 1
            maxIdForm = 0
          } else {
            this.questionData.forEach((item) => {
              if (item.id_Question > maxId) {
                maxId = item.id_Question
              }
            })
            this.questionData.forEach((item) => {
              if (item.id_Form_Type > maxIdForm) {
                maxIdForm = item.id_Form_Type
              }
            })
            maxId++
          }
          this.questionData.push({
            id_Question: maxId,
            nam_Question: this.newQuestion,
            id_Form_Type: maxIdForm,
          })

          this.newQuestion = ''
          setTimeout(() => {
            this.showModalNewQuestion = false
          }, 0)
        }
      } else {
        console.error('El elemento inputQuestion no es un input válido.')
      }
    },
    sendQuestions () {
      if (this.questionData.length === 0) {
        const errorMessage = 'No puede guardar sin preguntas'
        this.validationErrorMessageAdd2 = errorMessage
        this.isValidationErrorVisibleAdd2 = true
        setTimeout(() => {
          this.isValidationErrorVisibleAdd2 = false
        }, 3000)
      } else if (document.getElementById('inputNewQuestion')) {
        const errorMessage = 'No puede guardar si no ha terminado de crear las preguntas'
        this.validationErrorMessageAdd3 = errorMessage
        this.isValidationErrorVisibleAdd3 = true
        setTimeout(() => {
          this.isValidationErrorVisibleAdd3 = false
        }, 3000)
      } else {
        if (this.editIndex === '') {
          const requestData = {
            json_Data: JSON.stringify(this.questionData),
            id_Generic_Form: this.registQuestionData,
          }
          try {
            IberoHelpers.EvalDocenteAdmAddQuestion(this.$store, requestData)
          } catch (error) {
            console.log(error)
          }
          setTimeout(() => {
            this.showModalQuestionforQuestions = false
            this.confirmationMessageQuestions = false
            this.showModalQuestion = false
            this.showModalDetailI = false
            this.questionData = []
            this.questionRegist = 0
            this.registQuestionData = 0
            this.buttonDeleteQuestion = false
            setTimeout(() => {
              this.confirmationMessageQuestions = true
              setTimeout(() => {
                this.confirmationMessageQuestions = false
                this.tableUpdate()
              }, 3000)
            }, 200)
          }, 50)
        } else {
          const errorMessage = 'No puede tener preguntas con edición pendiente'
          this.validationErrorMessageAdd = errorMessage
          this.isValidationErrorVisibleAdd = true
          setTimeout(() => {
            this.isValidationErrorVisibleAdd = false
          }, 3000)
        }
      }
    },
    handleCheckboxChange (question) {
    // Desmarca todos los demás checkboxes
      this.questionData.forEach((q) => {
        if (q !== question) {
          q.type_Generic_Form = false // Cambia a falso para desmarcar
        }
      })
    },
  },
  computed: {
    dataEditValidator () {
      return this.formEditModel
    },
    validationActionValidator () {
      return this.validationActionM
    },
  },
}
</script>